'use client'

import type { ReactNode } from 'react'

import { useOptionalPageAnalytics } from '@/app/context/analytics'
import { buildLinkClick } from '@/app/lib/analytics/buildLinkClick'
import { PDP_BUY_CTA_CLICK_MODULE_NAME } from '@/app/lib/analytics/constants'

import styles from './ShareBar.module.scss'

interface ShareLinkProps {
  readonly href: string
  readonly network: string
  readonly ariaLabel: string
  readonly children: ReactNode
  /** `module_name` del click; por defecto el de la ficha de evento. */
  readonly moduleName?: string
}

/**
 * Enlace de compartir con su `click` outbound (`link_url` = URL completa del
 * servicio, `action_detail` = red). Hoja cliente: el resto de `ShareBar` sigue
 * siendo HTML de servidor.
 */
export function ShareLink({ href, network, ariaLabel, children, moduleName = PDP_BUY_CTA_CLICK_MODULE_NAME }: ShareLinkProps) {
  const analytics = useOptionalPageAnalytics()

  function handleClick() {
    analytics?.trackClick(
      buildLinkClick({
        clickType: 'outbound',
        clickSubtype: 'share',
        label: ariaLabel,
        href,
        moduleName,
        actionDetail: network,
      }),
    )
  }

  return (
    <a
      className={styles.link}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {children}
    </a>
  )
}
